import React, {useContext, useState, useEffect} from 'react';
import {NavLink, useHistory} from 'react-router-dom';
import {Nav, Navbar, NavDropdown} from 'react-bootstrap';
import {t} from 'react-switch-lang';
import NavbarNotification from './NavbarNotification';
import './Navbar.scss';
import LogoutIcon from './images/log-out.svg';
import LogoutBlue from './images/log-out-blue.svg';
import PageTitle from './pageTitle/PageTitle';
import {Settings} from './Language';
import SearchNavbar from '../searchNavbar/SearchNavbar';
import {getCurrentUser} from '../../services/accountService';
import axios from 'axios';
import {BASE_RESOURCE_URL, BASE_URL, token} from '../../utils/const';
import {GetUnreadNotificationApi} from '../../services/notifications/NotificationsApi';
import {
  fetchUserApi,
  fetchUserInChargeDepartments,
} from '../../services/administration/users/usersAPI';
import Swal from 'sweetalert2';
import {useUserContext} from '../../contexts/UserContext';
import roles from '../../utils/roles';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import * as Axios from 'axios';

const NavbarTop = (props) => {
  const [userData, setUserData] = useState([]);

  let history = useHistory();
  const userContext = useUserContext();

  const {dataChanged} = userContext;
  const [key, setKeyCount] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [numberNotification, setNumberNotification] = useState(0);
  const [initialsElementExists, setInitialsElementExists] = useState(false);
  const [departmentsUserInCharge, setDepartmentsUserInCharge] = useState([]);

  function getUserManualFile() {
    return Axios({
      url: `${BASE_RESOURCE_URL}/uploads/user_manual/RMS_korisnicko_uputstvo.pdf`, //your url
      method: 'get',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.setAttribute('download', t('navbar.userManual'));
      document.body.appendChild(link);
      link.click();
    });
  }

  function logout() {
    localStorage.removeItem('jwt-token-risk');
    localStorage.removeItem('webSocket_token_risk');
    localStorage.removeItem('language_risk');
    localStorage.removeItem('activeFilters');
    localStorage.removeItem('activeFiltersIncurred');
    localStorage.removeItem('activeFiltersCourt');
    localStorage.removeItem('departmentFilters');
    localStorage.removeItem('previous_link');
    history.push('/login');
  }
  const fetchUser = () => {
    getCurrentUser()
      .then((r) => {
        setProfileElementStyle(r.data);
      })
      .catch((r) => {
        Swal.fire({
          text: `${t('message.errorApi')}`,
          icon: 'error',
          confirmButtonText: 'OK',
        });
      });
  };
  // fetch user data again when profile image is updated
  useEffect(() => {
    fetchUser();
  }, [dataChanged]);

  const setProfileElementStyle = (user) => {
    const profileImageElement = document.querySelector('a#basic-nav-dropdown3');
    const userInitials = user.firstName[0] + user.lastName[0];
    const initialsElement = document.createElement('p');
    if (!initialsElementExists) {
      profileImageElement.appendChild(initialsElement);
    }
    if (user.imageUrl) {
      if (user.imageUrl.length > 0) {
        profileImageElement.innerHTML = '';
        // profileImageElement.style.backgroundImage = `url(${BASE_RESOURCE_URL}${user.imageUrl})`;
        initialsElement.style.display = 'none';
      } else {
        initialsElement.innerHTML = userInitials;
        initialsElement.style.display = 'block';
        profileImageElement.style.border = '1px solid #d3e1f5';
      }
    } else {
      initialsElement.innerHTML = userInitials;
      initialsElement.style.display = 'block';
      profileImageElement.style.border = '1px solid #d3e1f5';
    }
    setInitialsElementExists(true);
  };

  const notifications = () => {
    axios.get(`${BASE_URL}/notifications/unread?page=0&size=1000`);

    axios.get(`${BASE_URL}/notifications/read?page=0`);
  };

  useEffect(() => {
    {
      GetUnreadNotificationApi().then((res) => {
        setNumberNotification(res);
      });
    }
  }, [key]);

  useEffect(() => {
    {
      GetUnreadNotificationApi().then((res) => {
        setNumberNotification(res);
      });
    }
    setKeyCount(key + 1);
  }, [props.numberNotification]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getCurrentUser();
        setUserData(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  function readNotification() {
    if (numberNotification > 0 && props.connected) {
      props.client.send('/send/notification-ack', {});
      setNumberNotification(0);
    }
  }

  const departments = useDepartmentContext();
  const userAuthorities = useUserContext().authorities;
  const userInCharge = userAuthorities.some((r) =>
    r.includes(roles.role_user_in_charge)
  );
  const userSuperAdmin = userAuthorities.some((r) =>
    r.includes(roles.role_super_admin)
  );

  const legalAffairsDepartment = departments.some((r) => r.id === 9);
  const userInChargeId = departments.filter((r) => r.id === 9);
  const litigationInCharge = userInCharge || (userInChargeId[0]?.userInChargeId === userContext.id);



  return (
    <Navbar
      style={{
        paddingLeft: '31px',
        paddingRight: '30px',
      }}
      bg="light"
      expand="lg"
    >
      <div>
        <PageTitle title={props.pageTitle} />
      </div>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <div className="d-flex justify-content-end flex-wrap w-100 dd-navbar-container">
          <div className="d-flex dd-navbar-items">
            {!userContext.authorities.includes('ROLE_ADMIN') && (
              <NavDropdown
                title=""
                id="basic-nav-dropdown0"
                className={
                  'dropdown-menu-right top-nav-search-icon dropdownNav mx-0 ' +
                  (showSearchBar ? ' icon-blue' : '')
                }
                onClick={() => setShowSearchBar(!showSearchBar)}
              />
            )}
            {!userContext.authorities.includes('ROLE_ADMIN') && (
              <Nav className={' search-bar' + (showSearchBar ? '' : ' hide')}>
                <SearchNavbar showSearchBar={showSearchBar} />
              </Nav>
            )}

            {userInCharge || userSuperAdmin ? (
              <NavDropdown
                title=""
                id="basic-nav-dropdown1"
                className="dropdown-menu-right dropdownNav mx-0 ml-lg-4"
              >
                <span className="dropdown-arrow"></span>{' '}
                <NavDropdown.Item
                  className="item-border"
                  as={NavLink}
                  to="/potential-risk/add"
                >
                  {t('navbar.potentialRisk')}
                </NavDropdown.Item>
                <NavDropdown.Item
                  className="item-border"
                  as={NavLink}
                  to="/incurred-risk/add"
                >
                  {t('navbar.resultingAdverseEvent')}
                </NavDropdown.Item>
                {litigationInCharge || userSuperAdmin ? (
                  <NavDropdown.Item as={NavLink} to="/court-risk/add">
                    {t('navbar.litigation')}
                  </NavDropdown.Item>
                ) : (
                  ''
                )}
              </NavDropdown>
            ) : (
              ''
            )}

            {notifications !== undefined && (
              <NavDropdown
                title=""
                id="basic-nav-dropdown2"
                className="dropdown-menu-right basic-nav-dropdown2 dropdownNav mx-0 ml-lg-3"
                onClick={() => readNotification()}
              >
                <NavbarNotification
                  setNumberNotification={setNumberNotification}
                  numberNotification={numberNotification}
                  key={numberNotification}
                  client={props.client}
                  connected={props.connected}
                />
              </NavDropdown>
            )}
            {numberNotification !== 0 && (
              <div className="navNotificationNumber" key={key}>
                {numberNotification}
              </div>
            )}

            <NavDropdown
              title=""
              id="basic-nav-dropdown3"
              className="dropdown-menu-right dropdownNav mx-0 ml-lg-3"
            >
              <span className="dropdown-arrow"></span>

              <Settings />

              <NavDropdown.Item
                  as={NavLink}
                  to="/app-details"
              >
                <p className="profile-link-text"> {t('userManual.appDetails')}</p>
                {/*<a className="profile-link-text" id="logout-link-text" href={"http://localhost:8080/uploads/user_manual/RMS_korisnicko_uputstvo.pdf"}>*/}
                {/*{' '}*/}

                {/*</a>*/}
              </NavDropdown.Item>
              <NavDropdown.Item onClick={logout}>
                <p className="profile-link-text" id="logout-link-text">
                  {' '}
                  {t('navbar.logout')} <img src={LogoutIcon} alt="" />
                  <img src={LogoutBlue} alt="" />
                </p>
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarTop;
